import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ErrorConfig, NotFoundComponent} from '../../components/error/not-found/not-found.component';

@Component({
  selector: 'app-page-error',
  imports: [
    NotFoundComponent
  ],
  templateUrl: './page-error.component.html',
  styleUrl: './page-error.component.scss'
})
export class PageErrorComponent {
  private readonly route = inject(ActivatedRoute);

  readonly error: ErrorConfig = (() => {
    const code = this.route.snapshot?.url?.[0]?.path;

    if (code === '403') {
      return {
        image: 'assets/img/illu_403.svg',
        headline: 'default.error403.headline',
        buttonLabelKey: 'default.error403.goToHome'
      };
    }

    if (code === '404') {
      return {
        image: 'assets/img/illu_404.svg',
        headline: 'default.error404.headline',
        buttonLabelKey: 'default.error404.goToHome'
      };
    }

    return {
      image: 'assets/img/illu_404.svg',
      headline: 'default.error404.headline',
      buttonLabelKey: 'default.error404.goToHome',
    };
  })();
}
